/**
 * Actions for add phone
 */
export const actions = {
  /**
   * Add selected phone
   * @param {Object} context
   */
  async addSelectedPhone(context, user) {
    // Step 1: Data sanitization
    if (!user) {
      return false;
    }

    // Step 2: Create default request
    let request = false;

    // Step 3: Phone number sanitization
    let phone = user.phone.split("-").join("");
    phone = isNaN(phone) ? false : parseInt(phone);
    if (!phone) {
      return false;
    }

    // Step 3: Create the request according to the type
    if (user.type === "other_event") {
      request = {
        otherevent_id: user.id,
        person_id: isNaN(user.user_id) ? 0 : parseInt(user.user_id),
        phone: phone
      };
    } else {
      request = {
        otherevent_id: 0,
        person_id: user.id,
        phone: phone
      };
    }

    // Step 4: Update the selected phone in the local state as we
    //  don't need to wait for the response
    if (user.type === "person") {
      context.commit("clients/addSelectedPhone", user, { root: true });
    }
    context.commit("addSelectedPhone", user, { root: true });

    // Step 5: Send the request
    await context.dispatch(
      "makeAuthRequest",
      {
        url: "phone_selected/add",
        method: "POST",
        data: request
      },
      { root: true }
    );
  }
};
